module.exports = __webpack_public_path__ + "img/total_persentase_sp2d_anggaran.792ec43d.png";